export default __webpack_public_path__ + "static/media/avatar.fa084658.svg";